import { render, staticRenderFns } from "./Markdown.vue?vue&type=template&id=58cc3b74&scoped=true&"
import script from "./Markdown.vue?vue&type=script&lang=ts&"
export * from "./Markdown.vue?vue&type=script&lang=ts&"
import style0 from "./Markdown.vue?vue&type=style&index=0&id=58cc3b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cc3b74",
  null
  
)

export default component.exports